import { EntraIdService } from '../services/entra-id.service';

export function entraIdProviderFactory(entraIdService: EntraIdService) {
  return () => {
    return new Promise((resolve) => {
      entraIdService.init();
      resolve(null);
    });
  };
}
